'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeRequestActionTypes = undefined;

var _RequestActionTypes = require('../constants/RequestActionTypes');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var makeRequestActionTypes = exports.makeRequestActionTypes = function makeRequestActionTypes(actionName) {
  var _ref;

  return _ref = {}, _defineProperty(_ref, _RequestActionTypes.STARTED, actionName + '_STARTED'), _defineProperty(_ref, _RequestActionTypes.SUCCEEDED, actionName + '_SUCCEEDED'), _defineProperty(_ref, _RequestActionTypes.FAILED, actionName + '_FAILED'), _defineProperty(_ref, _RequestActionTypes.UNINITIALIZED, actionName + '_UNINITIALIZED'), _ref;
};